import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageDialog } from '../models/message-dialog';

@Component({
  selector: 'app-message-dialog',
  templateUrl: './message-dialog.component.html',
  styleUrls: ['./message-dialog.component.css']
})
export class MessageDialogComponent implements OnInit {

  title: string;
  message: string;

  constructor(public dialogRef: MatDialogRef<MessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: MessageDialog) {
      this.title = this.data.title;
      this.message = (this.data.message ?? '').replace(new RegExp('\n', 'g'), '<br />');
  }

  ngOnInit(): void {
  }

  onAccept() {
    this.dialogRef.close(true);
  }
}
